/* Custom (Elivado, 2026-09-18): kolomkeuze op collectiepagina's onthouden.
   Origineel (Madrid) zette alleen het attribuut bij een klik; de keuze ging verloren bij
   een volgende pagina, filteren of sorteren. Nu bewaard in localStorage en opnieuw toegepast. */
(function () {
	if (window.__perRowInit) return;
	window.__perRowInit = true;

	const KEY = "vintasje:products-per-row";

	const read = () => {
		try {
			const value = window.localStorage.getItem(KEY);
			return value && /^[a-z0-9_-]+$/i.test(value) ? value : null;
		} catch (e) {
			return null;
		}
	};

	const write = (value) => {
		try {
			window.localStorage.setItem(KEY, value);
		} catch (e) {}
	};

	const apply = (value) => {
		if (!value) return;
		const buttons = document.querySelectorAll(".per-row__button");
		if (!buttons.length) return;
		if (!document.querySelector('.per-row__button[data-per-row="' + value + '"]')) return;

		buttons.forEach((button) => {
			button.classList.toggle("active", button.dataset.perRow === value);
		});
		document.querySelectorAll("[data-productis-in-row]").forEach((grid) => {
			if (grid.getAttribute("data-productis-in-row") !== value) {
				grid.setAttribute("data-productis-in-row", value);
			}
		});
	};

	const restore = () => apply(read());

	document.addEventListener("click", (event) => {
		const button = event.target.closest(".per-row__button");
		if (!button) return;
		const value = button.dataset.perRow;
		write(value);
		apply(value);
	});

	document.addEventListener("shopify:section:load", restore);

	// Filteren, sorteren en 'meer laden' vervangen het raster via AJAX: keuze opnieuw toepassen.
	const observe = () => {
		const root = document.getElementById("MainContent") || document.body;
		if (!root || !window.MutationObserver) return;
		new MutationObserver(restore).observe(root, { childList: true, subtree: true });
	};

	restore();
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => {
			restore();
			observe();
		});
	} else {
		observe();
	}
})();
